import { Injectable } from '@angular/core';

import { pontosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute, configuracaoRoute } from "../../../shared/services/data.service";
import { viagensRoute } from "../../shared/data.service";

@Injectable()
export class PontoNavigationService {
    moduleRouter: string = pontosRoute;
    fatherRouter: string = viagensRoute;
    configuracaoRoute: string = configuracaoRoute;

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute  + '/' + this.moduleRouter;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/shared/ponto-navigation.service.ts
 **/